import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, Core2Config } from '../../shared';
import { MlmLineageContainerModel } from '../../../../../../models/aggregates/erp/mlm-admin';


@Injectable({ providedIn: 'root' })
export class MlmLineageService extends BaseApiTemplateService<MlmLineageContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'mlm/lineages';
  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'mlm/lineages';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX  + 'mlm/lineages';
    this.httpClient = theHttp;
  }


}

